import { Icon_TriangleDown } from "@shapr3d/frontend-lib";

import { Avatar } from "../../../Comment/Avatar";

import style from "./AccountButton.module.css";

export const AccountButton: React.FC<{ name?: string; onClick?: () => void }> = ({
  name,
  onClick,
}) => {
  return (
    <div className={style.emailAvatarContainer} onClick={onClick}>
      <Avatar title={name ?? "Unknown user"} />
      <div className={style.emailContainer}>
        <span className={style.email}>{name ?? "Unknown user"}</span>
        <Icon_TriangleDown />
      </div>
    </div>
  );
};
